import { throwError, Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { Response } from '@angular/http';
import { StsHttpService } from './sts-http.service';
import { StsErrorResponse } from '../models/sts-error-response';
import {StsTotpResponse} from '../models/sts-totp-response.model';
import { StsAuthMethods } from '../models/sts-authmethods.model';


@Injectable()
export class StsTfaRegServiceService {

  constructor(private http: StsHttpService) {
  }

  public setEmailAsVerified(email: string):
    Observable<StsErrorResponse> {
    return new Observable<StsErrorResponse>(o => {
      let url = '/api/users/set/email/verified';
      this.http.post<StsErrorResponse>(url, {
        email: email
      }).subscribe(
        (q: StsErrorResponse) => {
          o.next(q);
          o.complete();
        }, (err: StsErrorResponse) => {
          console.log(err);
          o.next(err);
          o.complete();
        });
    });
  }

  public setPhoneAsVerified(phone: string):
    Observable<StsErrorResponse> {
    return new Observable<StsErrorResponse>(o => {
      let url = '/api/users/set/phone/verified';
      this.http.post<StsErrorResponse>(url, {
        email: phone
      }).subscribe(
        (q: StsErrorResponse) => {
          o.next(q);
          o.complete();
        }, (err: StsErrorResponse) => {
          console.log(err);
          o.next(err);
          o.complete();
        });
    });
  }

  public sendValidationEmail(dest: string, address: string,
                             validate = false):
    Observable<StsErrorResponse> {
    return new Observable<StsErrorResponse>(o => {
      let url = validate ? '/api/users/authenticate/email' : '/api/users/validate/email';
      this.http.post<StsErrorResponse>(url, {
        address: address,
        destination: dest
      }).subscribe(
        (q: StsErrorResponse) => {
          o.next(q);
          o.complete();
        }, (err: any) => {
          console.log(err);
          const apiResponse = new StsErrorResponse();  
          apiResponse.success = false;
          apiResponse.stsCode ='tooManyRequests';
          o.next(apiResponse);
          o.complete();
        });
    });
  }

  public validateCode(code: string,
                      trust = false,
                      validate = false): Observable<StsErrorResponse> {
    return new Observable<StsErrorResponse>(o => {
      let url = validate ? '/api/users/auth/code' : '/api/users/validate/code';
      this.http.post<StsErrorResponse>(url, {
        verificationCode: code,
        trust: trust
      }).subscribe(
        (q: StsErrorResponse) => {
          o.next(q);
          o.complete();
        }, (err: StsErrorResponse) => {
          console.log(err);
          o.next(err);
          o.complete();
        });
    });
  }

  public getQrCode(): Observable<StsTotpResponse> {
    let url = '/api/users/2fa/get/code';
    return new Observable<StsTotpResponse>(o => {
    this.http.post<StsTotpResponse>(url, {
      'qrCodeWidth': 150,
      'qrCodeHeight': 150,
      'qrCodeMargin': 1
    }).subscribe(
      (q: StsTotpResponse) => {
        o.next(q);
        o.complete();
      }, (err: StsTotpResponse) => {
        o.next(err);
        o.complete();
      });
    });
  }


  private handleError(error: Response | any) {
    // In a real world app, we might use a remote logging infrastructure
    let errMsg: string;
    if (error instanceof Response) {
      const body = error.json() || '';
      const err = body.error || JSON.stringify(body);
      errMsg = `${error.status} - ${error.statusText || ''} ${err}`;
    } else {
      errMsg = error.message ? error.message : error.toString();
    }
    return throwError(errMsg);
  }

  public authMethods(dest: string, address: string): Observable<StsAuthMethods[]> {
    return new Observable<StsAuthMethods[]>(resend => {
      let url = '/api/users/tfa/authmethods';

      this.http.post<StsAuthMethods[]>(url, {
        address: address,
        destination: dest
      }).subscribe(
        (q: StsAuthMethods[]) => {
          resend.next(q);
          resend.complete();
        }, (err: StsAuthMethods[]) => {
          console.log(err);
          resend.next(err);
          resend.complete();
        });
    });
  }

}
